import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useRouter } from 'vue-router/composables';

import { HeadingDisplay, ButtonPrimary } from '@warrenbrasil/nebraska-web';
import { Money } from '@/modules/common/components/MoneyV2';
import { HeadingDisplayLoader } from '@/modules/trade/components/HeadingDisplayLoader';
import { SectionError } from '@/modules/common/components/SectionError';

import { IPortfolioDistributionResponse } from '@/modules/wallet-builder/src/services/types/models/IBffInvestments';
import { IBalance } from '@/modules/wealth/services/investment/investment-types';

import { trackInvestPortfolio, trackWithdrawPortfolio } from './track-events';

import { CustomerModule } from '@/modules/common/store/CustomerModule';
import { GoalType } from '@/types/models/Portfolio';

import {
  userCanPerform,
  Operation,
  isImpersonate
} from '@/modules/common/services/partner';

interface Props {
  isLoading?: boolean;
  hasError?: boolean;
  portfolioDetails?: IPortfolioDistributionResponse;
  portfolioBalance?: IBalance;
}

interface Emits {
  (e: 'on-retry'): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  props: {
    isLoading: { type: Boolean, default: true },
    hasError: { type: Boolean, default: false },
    portfolioDetails: { default: undefined },
    portfolioBalance: { default: undefined }
  },
  emits: ["on-retry"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'on-retry'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { isLoading: boolean, hasError: boolean, portfolioDetails: IPortfolioDistributionResponse, portfolioBalance: IBalance }

const router = useRouter();





function emitOnRetry() {
  emits('on-retry');
}

const portfolioName = computed(() => {
  return props.portfolioDetails?.portfolio.name;
});

const canInvestPortfolio = computed(() => {
  return props.portfolioDetails?.portfolio.canInvestInPortfolio;
});

const redemptionAllowed = computed(() => {
  return props.portfolioDetails?.portfolio.redemptionAllowed;
});

const isCustom = computed(() => {
  return props.portfolioDetails?.portfolio.isCustom;
});

const portfolioId = computed(() => {
  return props.portfolioDetails?.portfolio.id;
});

const isPrivatePension = computed(() => {
  return props.portfolioDetails?.portfolio.goal === GoalType.PRIVATE_PENSION;
});

const totalBalance = computed(() => {
  return props.portfolioBalance?.totalGrossWorth.formatted;
});

const totalBalanceUpdatedAt = computed(() => {
  return props.portfolioBalance?.totalBalanceUpdatedAtFormatted;
});

const isInvestButtonDisabled = computed(() => {
  if (isImpersonate()) return partnerCantPerform.value;

  return !canInvestPortfolio.value;
});

const partnerCantPerform = computed(() => {
  if (!isCustom.value) return !canInvestPortfolio.value;

  if (isPrivatePension.value) return !canInvestPortfolio.value;

  return (
    Boolean(!userCanPerform(Operation.DepositByProduct)) ||
    !canInvestPortfolio.value
  );
});

const isRegulatoryStatusBlocked = computed(() => {
  return CustomerModule?.isRegulatoryStatusBlocked;
});

function handleInvestmentClick() {
  if (isRegulatoryStatusBlocked.value) {
    redirectToRegulatoryUpdate();
    return;
  }

  trackInvestPortfolio(portfolioName.value);

  if (isCustom.value) {
    redirectToInvestmentByProduct();
    return;
  }

  redirectToInvestmentByPortfolio();
}

function redirectToRegulatoryUpdate() {
  router.push({
    name: 'wealth',
    query: { regulatoryModal: 'true' }
  });
}

function redirectToWithdraw() {
  trackWithdrawPortfolio(portfolioName.value);

  if (isCustom.value) {
    redirectToWithdrawByProduct();
    return;
  }

  redirectToWithdrawByPortfolio();
}

function redirectToWithdrawByProduct() {
  router.push({
    name: 'wealthProductWithdrawal',
    params: {
      id: portfolioId.value
    }
  });
}

function redirectToWithdrawByPortfolio() {
  router.push({
    name: 'wealthPortfolioWithdrawal',
    params: { id: portfolioId.value }
  });
}

function redirectToInvestmentByPortfolio() {
  router.push({
    name: 'investment-transaction',
    params: { portfolio: portfolioId.value }
  });
}

function redirectToInvestmentByProduct() {
  router.push({
    name: 'wealthProductTransaction',
    params: { id: portfolioId.value }
  });
}

return { __sfc: true,router, props, emits, emitOnRetry, portfolioName, canInvestPortfolio, redemptionAllowed, isCustom, portfolioId, isPrivatePension, totalBalance, totalBalanceUpdatedAt, isInvestButtonDisabled, partnerCantPerform, isRegulatoryStatusBlocked, handleInvestmentClick, redirectToRegulatoryUpdate, redirectToWithdraw, redirectToWithdrawByProduct, redirectToWithdrawByPortfolio, redirectToInvestmentByPortfolio, redirectToInvestmentByProduct, HeadingDisplay, ButtonPrimary, Money, HeadingDisplayLoader, SectionError }
}

})